__turbopack_context__.v({
  "brandBackground": "-LzqAG_brandBackground",
  "brandDescription": "-LzqAG_brandDescription",
  "brandOutlineButton": "-LzqAG_brandOutlineButton",
  "brandPrimaryButton": "-LzqAG_brandPrimaryButton",
  "primaryButton": "-LzqAG_primaryButton",
  "textureOverlay": "-LzqAG_textureOverlay",
});
